import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "layouts/authentication/components/Footer";

function BasicLayout({ image, video, children }) {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        overflow="hidden"
        sx={{
          ...(video
            ? {
                overflow: "hidden",
                "& video": {
                  minWidth: "100%",
                  minHeight: "100%",
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  objectFit: "cover",
                  zIndex: -1,
                },
              }
            : {
                backgroundImage: ({
                  functions: { linearGradient, rgba },
                  palette: { gradients },
                }) =>
                  image &&
                  `${linearGradient(
                    rgba(gradients.dark.main, 0.6),
                    rgba(gradients.dark.state, 0.6)
                  )}, url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }),
        }}
      >
        {video && (
          <video autoPlay loop muted>
            <source src={video} type="video/mp4" />
            Tu navegador no soporta el tag de video.
          </video>
        )}
      </MDBox>
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      <Footer light />
    </PageLayout>
  );
}
BasicLayout.propTypes = {
  image: PropTypes.string,
  video: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
